<template>
    <div class="container" style="max-width: 987px !important;">
        
        
        <div class="whiteBgSec_1">
            <button class="closeBtn" @click="$emit('closed', '')"><i class="fa-solid fa-xmark"></i></button>
            <h2 class="text-center">Get Tokens</h2>
            <p class="text-center subHeading">Join the fun! Purchase AI-Tokens and start <br> transforming your ideas into stunning designs.</p>
            <div class="row py-5">
                <div class="col-md-4 mb-5">
                    <div class="getCoinBx" >
                        <label for="promoCode">Enter Promo Code:</label>
                        <input id="promoCode" type="text" class="form-control" v-model="frm_promo.code"   name="code">
                         
                        <div class="row pt-3">
                            <div class="col-12 text-end">
                                <button class="gradientBtn_2" type="button" @click="apply_promo()">Enter</button>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-for="(item,x) in packages" >
                <div class="col-md-4 mb-5" :key="x+'-'+item._id" v-if="item._id" >
                    <div class="getCoinBx_2">
                        <h4><sup>$</sup> <span>{{ item.price }}</span> <sub>/one-time patyment</sub></h4>
                        <img src="assets/images/getCoin_1.jpg" alt="">
                        <h3>{{ item.credits }} <br><span>AI</span>-Tokens</h3>
                        <button class="purchaseBtn" @click="purchese_pack(x+1)">Purchase</button>
                        <div class="discount" v-if="item.discount">Save {{ item.discount }}%</div>
                    </div>
                </div>
            </template>
            </div>
            <div class="row">
                <div class="col-12">
                    <p><strong>10</strong> Tokens is equivelent to <strong>1</strong> AI generation</p>
                </div>
            </div>
    
        </div>
        
        <div class="modal fade" id="payment_pop" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form class="modal-content" @submit.prevent="submit_payment()">
                <div class="modal-header">
                    <h2 class="modal-title h4" id="exampleModalLabel">Card Info</h2>
                     
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>
                <div class="modal-body py-5 vld-parent" ref="CHshipping_cng_ref">
                   
                    <div class="col-sm-5 col-lg-4 paymentIcon">
                        <a href="javascript:void(0);"><img src="images/payment-icon01.png"></a>
                        <a href="javascript:void(0);"><img src="images/payment-icon02.png"></a>
                        <a href="javascript:void(0);"><img src="images/payment-icon03.png"></a>
                    </div>
    
                    <div class="col-md-12 formSection_2" >
                        <div class="form-group">
                            <label class="haveToolTip">Card Number
                                <span class="icons help">
                                    <i :class="cardBrandClass" v-if="cardBrandClass"></i>
                                    <img v-else src="images/card.png" class="img-fluid" alt="">
                                </span>
                            </label>
                            <input type="text" name="card_number" class="form-control" v-model="PaymentCart.card_number" v-cardformat:formatCardNumber placeholder="#### #### #### ####"  v-validate="'required'" data-vv-as="card numbere" >
                            <p v-if="verrors.has('card_number')||cardErrors.cardNumber" class="text-danger">
                                {{ typeof cardErrors.cardNumber  == 'undefined' ? verrors.first('card_number') : cardErrors.cardNumber }}
                            </p>
                        </div>
    
                    <div class="form-group">
                        <div class="row">
                            <div class="col-6">
                            <label>Name on Card</label>
                            <input type="text" name="name_on_Card" class="form-control" v-model="PaymentCart.name_on_Card" ref="cardNameInput"  v-validate="'required'" data-vv-as="name on Card">
                            <p v-if="verrors.has('name_on_Card')" class="text-danger">{{ verrors.first('name_on_Card')  }}</p>
                        </div>
                        <div class="col-6">
                            <label>Expiration Date</label>
                            <input type="text" placeholder="MM/YY" name="exp_date" class="datepicker form-control"
                                v-model="PaymentCart.exp_date" v-cardformat:formatCardExpiry  v-validate="'required'" data-vv-as="expiry date">
                            <p v-if="verrors.has('exp_date')||cardErrors.cardExpiry" class="text-danger">
                                {{ typeof cardErrors.cardExpiry  == 'undefined' ? verrors.first('exp_date') : cardErrors.cardExpiry }}
                            </p>
                        </div>
                        <div class="col-6">
                            <label class="haveToolTip">CVV Code <span class="icons help" v-tooltip="'It\'s the 3-digit number on the back of the card'"><img src="images/help.png" class="img-fluid" alt=""></span></label>
                            <input type="password" name="cvv" class="form-control" v-model="PaymentCart.cvv" v-cardformat:formatCardCVC ref="cardCvvInput"  v-validate="'required'" data-vv-as="CVV">
    
                            <p v-if="verrors.has('cvv')||cardErrors.cardCvc" class="text-danger">
                                {{ typeof cardErrors.cardCvc  == 'undefined' ? verrors.first('cvv') : cardErrors.cardCvc }}
                            </p>
                        </div>
                        </div>
                        
                    </div>
    
                    </div> 
    
                </div>
                <div class="modal-footer justify-content-center">
                    <div class="row">
                        
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-primary m-2">Complete Purchase</button>
                        </div>
                    </div>
                    
                    
                </div>
            </form>
        </div>
    </div>
    
    </div>
    </template>
    
    <script>
    import { mapActions, mapGetters } from "vuex";
    import axios from "axios";  
    export default {  
        name:'GetCoinHomeowwner',
        data() {
            return {
                packages:{},
                orders: '',
                ppp:10,
                search:'',
                chosen_item:'',
                PaymentCart:{},
                cardErrors: {},
                cardBrand: null, 
                stripeToken: null,
                stripeAPIToken: '',
                pageLoader: false,
                credits:0,
                package_for:'Leads',
                no_of_promo:'',
                frm_promo:{}
            }
        },
        watch: {
            Setting: {
                handler(items) {
                    if (items){
                        this.stripeAPIToken = items.STRIPEPUBLICKEY2
                        this.configureStripe(); 
                    }
                },
                immediate: true,
                deep: true
            },
            stripeAPIToken(newToken) {
            if (newToken) { 
                this.configureStripe(); 
            }
            },
         },
        computed: {
            ...mapGetters("auth", ["user"]),
            ...mapGetters("Aiauth", ["Aiuser"]),
            ...mapGetters("Common", ["Setting"]),
            ...mapGetters({ 
                showroomId: "Common/MyItem", 
            }),
            ...mapGetters(["errors"]),
            cardBrandClass() {
                return this.getBrandClass(this.cardBrand);
            }
        },
        async mounted() {
            this.getSettingData()
           /* await this.includeStripe('js.stripe.com/v2/', function () {
                this.configureStripe();
            }.bind(this));*/

            await this.includeStripe('js.stripe.com/v2/', () => {
            console.log('Stripe script loaded.');
            });

        },
        methods: {            
            ...mapActions("Common", ["getSettingData" ]),
            async includeStripe(URL, callback) {
                let documentTag = document,
                    tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];
                object.src = 'https://' + URL;
                if (callback) {
                    object.addEventListener('load', function (e) {
                        callback(null, e);
                    }, false);
                }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },
            configureStripe() {
                console.log('cal stoken',this.stripeAPIToken)
                Stripe.setPublishableKey(this.stripeAPIToken);
            },
            purchese_pack(x){
                this.chosen_item=x
                $('#payment_pop').modal('show');
            },
            async submit_payment() {
                await this.$validator.validate().then((valid) => {
                    if (valid) {
                        this.cardErrors = {};
                        if (!this.$cardFormat.validateCardNumber(this.PaymentCart.card_number) && this.PaymentCart.card_number) {
                            this.cardErrors.cardNumber = "Invalid Card Number.";
                        };
                        if (!this.$cardFormat.validateCardExpiry(this.PaymentCart.exp_date) && this.PaymentCart.exp_date) {
                            this.cardErrors.cardExpiry = "Invalid Expiration Date.";
                        };
                        if (!this.$cardFormat.validateCardCVC(this.PaymentCart.cvv) && this.PaymentCart.cvv) {
                            this.cardErrors.cardCvc = "Invalid CVC.";
                        };
    
                        if (Object.keys(this.cardErrors).length == 0) {
                            this.pageLoader = true
                            let exp = this.PaymentCart.exp_date.split('/');
                            Stripe.createToken({
                                number: this.PaymentCart.card_number,
                                cvc: this.PaymentCart.cvv,
                                exp_month: exp[0].trim(),
                                exp_year: exp[1].trim()
                            }, this.stripeResponseHandler);
                            return false;
                        }
                    }
                });
            },
            async stripeResponseHandler(status, response) {
                if (response.error) {
                    this.cardErrors = {};
                    if (response.error.param == 'number') {
                        this.cardErrors.cardNumber = response.error.message;
                    };
                    if (response.error.param == 'exp_year') {
                        this.cardErrors.cardExpiry = response.error.message;
                    };
                    if (response.error.param == 'cvc') {
                        this.cardErrors.cardCvc = response.error.message;
                    };
                    if (typeof (response.error.param) === 'undefined' || (response.error.param != 'number' && response.error.param != 'exp_year' && response.error.param != 'cvc')) {
                        Toast.fire({
                            icon: 'warning',
                            title: response.error.message
                        });
                    }
                    this.pageLoader = false
                } else {
                    this.stripeToken = response['id']
                    let fdata = { 
                        stripeToken: response['id'],
                        user_id: this.Aiuser.id,
                        package_id:this.chosen_item,
                        user_type:'AI-user', 
                        no_of_promo:this.no_of_promo,
                        package_for:this.Aiuser.user_type
                    }
                    let ldr = this.$loading.show();
                    axios.post('/api/AI/buy_package', fdata)
                        .then(res => {
                            ldr.hide()
                            if (res.data.data) {
                                this.$root.$emit('reload_iframe',true)
                                $('#payment_pop').modal('hide');
                                this.PaymentCart={};
                                this.chosen_item='';
                                Toast.fire({
                                    icon: 'success',
                                    title: res.data.message
                                });
                            } else {
                                Toast.fire({
                                    icon: 'error',
                                    title: data.data.message
                                });
                            } 
                        })
                        .catch(err => {
                            ldr.hide()
                        });
                }
            },
            getBrandClass: function (brand) {
                let icon = '';
                brand = brand || 'unknown';
                let cardBrandToClass = {
                    'visa': 'fa fa-cc-visa',
                    'mastercard': 'fa fa-cc-mastercard',
                    'amex': 'fa fa-cc-amex',
                    'discover': 'fa fa-cc-discover',
                    'diners': 'fa fa-cc-diners-club',
                    'jcb': 'fa fa-cc-jcb',
                    'unknown': 'fa fa-credit-card',
                };
                if (cardBrandToClass[brand]) {
                    icon = cardBrandToClass[brand];
                };
                return icon;
            },
    

            async apply_promo() {
                
                    if (this.frm_promo.code) {
                    let ldr = this.$loading.show();
                    this.frm_promo.user_id=this.Aiuser.id
                    this.frm_promo.user_type='AI-user'
                    axios.post('/api/AI/promocode-apply', this.frm_promo)
                        .then(res => {
                            ldr.hide()
                            if (res.data.data) {
                                 this.$root.$emit('reload_iframe',true)
                                 this.frm_promo={}
                                Toast.fire({
                                    icon: 'success',
                                    title: res.data.message
                                });
                            } else {
                                Toast.fire({
                                    icon: 'error',
                                    title: data.data.message
                                });
                            } 
                        })
                        .catch(err => {
                            ldr.hide()
                        });

                    }else{
                        Swal.fire('Please enter Promo Code')
                    }
            }
        },
        
    
     
         beforeCreate(){
            axios.get('/api/AI/get_packages',{ params: {type:'AI-user'}})
                .then((res) => {
                    if (res.data.data) {
                        this.packages = res.data.data; 
                    } else {
                        this.packages = '' 
                    } 
                })
                .catch(err => { 
                }); 
         }
         
        
    };
    
    </script>
     
    <style>
    .paymentIcon {
      display: flex; /* Ensures all children are aligned in a row */
      gap: 10px; /* Adds spacing between anchors */
      flex-wrap: nowrap; /* Prevents wrapping to a new line */
      align-items: center; /* Vertically centers the images */
    }
    
    .paymentIcon a {
      display: inline-block; /* Ensures anchors are inline elements */
    }
    </style>